import React from 'react';

import { Button, Stack, Grid } from '@gogame/components';
import { FormFieldArray, withFormFieldGroupFormField } from '@gogame/form';

import HybridLinkParameterItem from './HybridLinkParameterItem';

const HybridLinkParameters = ({ name, value }) => {
  return (
    <FormFieldArray name={name}>
      {({ unshift, remove }) => {
        return (
          <Stack spacing={2}>
            <div>
              <Button add onClick={() => unshift('')} color={'primary'}>
                Link Parameter
              </Button>
            </div>

            {value?.length ? (
              <div>
                <Grid container spacing={3}>
                  {value.map((_, i) => {
                    return (
                      <Grid item xs={12}>
                        <HybridLinkParameterItem
                          name={`[${i}]`}
                          onRemove={() => remove(i)}
                          key={i}
                        />
                      </Grid>
                    );
                  })}
                </Grid>
              </div>
            ) : null}
          </Stack>
        );
      }}
    </FormFieldArray>
  );
};
export default withFormFieldGroupFormField()(HybridLinkParameters);
